module.exports = __webpack_public_path__ + "50c787e0afd0999cdbe8e685ac5e0c7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-rosario.jpg
// module id = 1545
// module chunks = 0